module.exports = __webpack_public_path__ + "static/media/algemeen.32c07b9c.svg";